// extracted by mini-css-extract-plugin
export default {"containerBoxShare":"shareTrack_containerBoxShare__KY8Un","textShare":"shareTrack_textShare__tkioY","textTrack":"shareTrack_textTrack__F3ZHP","btnShare":"shareTrack_btnShare__723nv"};